<template>
	<div class="treebox" @mouseleave="mouseLeave">
		<div class="ipt">
			<p class="el-icon-close" @click="close" v-if="editshow==true"></p>
      <el-form-item type="type" label="淤地坝名称" prop="queryval">
        <el-input :disabled="editshow==false" ref="input_blur" v-model="queryval" placeholder="淤地坝名称" class="querys" @focus="queryfocus"></el-input>
      </el-form-item>
			<!-- @blur="queryblur"-->
		</div>
		<transition name="el-zoom-in-top">
			<div class="treeClass">
				<el-tree v-show="treeShow" :default-expand-all='true' :expand-on-click-node="false" ref="tree" :filter-node-method="filterNode" :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
		</transition>
	</div>
</template>

<script>
	import { ydbtree } from '@/api/api.js'
	export default {
    props: ['currentdata'],
		data() {
			return {
				queryval: '',
				treeShow: false,
				treedata: [],
				defaultProps: {
					children: 'children',
					label: 'city',
				},
        editshow: true,
			}
		},

		mounted() {
			let params = {};
			ydbtree(params).then((res) => {
				//console.log(res.data)
				this.treedata = res.data
			});
      if (this.currentdata) {
        this.queryval = this.currentdata;
        this.editshow = false;
      }
		},
		methods: {
			close() {
				this.queryval = '';
				this.$emit("close", '');
			},
			queryfocus() {
				this.treeShow = true;
			},
			valblur() {
				let _this = this;
				setTimeout(function() {
					//_this.treeShow = false;
				}, 400)
			},
			handleNodeClick(data) {
				this.queryval = data.city;
				this.$emit("obj", data);
				let _this = this;
				setTimeout(function() {
					_this.treeShow = false;
				}, 400)
			},
			filterNode(value, data) {
				if(!value) return true;
				return data.city.indexOf(value) !== -1;
			},
			mouseLeave() {
				let _this = this;
				setTimeout(function() {
					_this.treeShow = false;
					_this.$refs.input_blur.blur()
				}, 200)
			},
		},
		watch: {
			queryval(val) {
				this.$refs.tree.filter(val)
			}
		}
	}
</script>

<style scoped>
	.treebox {
		/* width: 300px; */
		position: relative;
		float: left;
		/* margin-right: 10px; */
		/* margin-top: 10px; */
	}

	.ipt {
		width: 100%;
		height: 30px;
		display: block;
		/* margin: 0 auto; */
		position: relative;
	}

	.ipt p {
		position: absolute;
		right: 12px;
		top: 0px;
		font-size: 14px;
		color: #606266;
		z-index: 100;
		line-height: 30px;
		font-weight: 600;
		cursor: pointer;
	}

	.querys {
		height: 30px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		padding-left: 10px;
		font-size: 14px;
	}

  >>>.el-icon-close {
    padding-top: 5px;
  }

	.treeClass {
		position: absolute;
		top: 30px;
		left: 100px;
		right: 0px;
		z-index: 3000;
		max-height: 300px;
		overflow: auto;
		box-shadow: 0 0 10px #e0e0e0;
		border-radius: 5px 5px 10px 10px;
	}
</style>
